import React, {Component, Fragment} from "react";
import PropTypes from "prop-types";
import autobind from "autobind-decorator";
import { connect } from "react-redux";
import { Container, Row, Col,InputGroup, InputGroupAddon, Button, Input, UncontrolledTooltip, FormGroup, Label} from 'reactstrap';
import { SketchPicker as ColorPicker } from 'react-color';
import Select from 'react-select';
import makeAnimated from 'react-select/lib/animated';

import http from "../../../../services/HttpService";
import {Redirect} from "react-router";
import Route from "../../../../Routes";
import Loading from "../../../includes/Loading";

import { FilePond, registerPlugin, create } from 'react-filepond';
import 'filepond/dist/filepond.min.css';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import FilePondPluginFilePoster from 'filepond-plugin-file-poster';
import 'filepond-plugin-file-poster/dist/filepond-plugin-file-poster.css';

import swal from "sweetalert2";
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview, FilePondPluginFilePoster);
import i18next from 'i18next';
import { Translation } from "react-i18next";

import { Editor } from '@tinymce/tinymce-react';

import LayoutDashboard from "../../../../views/layout/Dashboard";
import {layout} from "../../../../../ts-helpers/decorators";

@layout(LayoutDashboard)
@(connect((state) => {
    return { };
}) as any)

export default class EditAbout extends Component<any> {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
    };

    filePond = null;

    state = {
        about_text: "",
        image: [],
        valid: {
            about_text: true,
            image: true,
        },
        loading: true,
        updated: false,
    };

    constructor(props: Map<any, any>) {
        super(props);
        this.filePond = React.createRef();
    }

    componentDidMount(): void {
        this.getData();
        this.props.onRef(this);
    }


    @autobind
    getData(){
        http.get(`/abouts/all`)
            .then(response => response.json())
            .then((data) => {

                this.createFile('/', data.about_image)
                    .then((file) => {
                        const image = [file];

                        this.setState({
                            loading: false,
                            about_text: data.about_text,
                            image,
                        });
                    });

            })
    }

    async createFile(url, title) {
        let response = await http.get(url + title);
        let data = await response.blob();

        return new File([data], title, {
            type: response.headers.get("Content-Type"),
        });
    }

    @autobind
    updateAbout(event) {
        event.preventDefault();
        const { about_text, valid, image } = this.state;

        if (!valid.about_text || !valid.image) {
            const list = [];

            !valid.about_text && list.push("About text");
            !valid.image && list.push("About image");

            const message = 'Please fill following fields: ' + list.join(', ');
            swal.fire('Failed', message, 'error');

            return;
        }

        const formData = new FormData();
        formData.append("about_text", about_text);
        formData.append("about_image", image[0] ? image[0].file : null);

        http.withFormData( 'POST','/abouts/add', formData)
            .then((response: any) => {
                if (response.ok) {
                    swal.fire('Done', 'About successfully added.', 'success')
                        .then(() => {
                            this.setState({
                                updated: true,
                            });
                        });
                } else {
                    swal.fire('Failed', 'Something went wrong.', 'error');
                }
            })
            .catch((err) => {
                swal.fire('Failed', 'Something went wrong.', 'error');
            });
    }

    @autobind
    handleEditorChange(event,editor){
        const { valid } = this.state;
        const about_text = editor.getContent();

        if (about_text == "") {
            valid.about_text = false;
        } else {
            valid.about_text = true;
        }

        this.setState({
            about_text,
            valid,
        });
    }

    @autobind
    changeImage(files) {
        const { valid } = this.state;
        if (files.length == 0) {
            valid.image = false;
        } else {
            valid.image = true;
        }

        this.setState({
            image: files,
            valid,
        });
    }

    @autobind
    changeLanguage(e) {
        const lng = e.currentTarget.dataset.lang
        this.setState({ lng: lng }, () => {
            i18next.changeLanguage(lng);
            this.props.changeLang();
        });
    }

    @autobind
    langTranslation(e){
        return <Translation>{t => t(`${e}`)}</Translation>
    }

    render() {
        const { loading, about_text, updated, image } = this.state;
        if (updated) {
            return <Redirect to={Route.toUrl("dashboard_home")} />
        }

        return(
            <Container fluid>
                <Row>
                    <Col sm="12">
                        <h4 className="header-title m-t-0 m-b-20">About!</h4>
                    </Col>
                </Row>

                {
                    loading ? <Container><Row><Col className="text-center"><Loading isLoading={loading} icon="loadDashboardInfo" /></Col></Row></Container> :
                        <Fragment>
                            <Row>
                                <Col className="dashboard_add_style_block col-sm-offset-3 col-sm-6">
                                    <form onSubmit={this.updateAbout}>
                                        <Row>
                                            <Col>
                                                <FormGroup className="mt-4">
                                                    <Label for="image" className="dashboard_forms_label">Image<sup className="my_sup_class">*</sup></Label>
                                                    <FilePond allowMultiple={false} files={image} ref={this.filePond}
                                                              onupdatefiles={this.changeImage} acceptedFileTypes={['image/*']}
                                                    />
                                                </FormGroup>
                                                <FormGroup>
                                                    <Label for="text" className="dashboard_forms_label">About text<sup className="my_sup_class">*</sup></Label>
                                                    <Editor
                                                        initialValue={about_text}
                                                        init={{
                                                            height: 500,
                                                            menubar: false,
                                                            plugins: [
                                                                'print preview paste importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap quickbars emoticons'
                                                            ],
                                                            toolbar:
                                                                'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl'
                                                        }}
                                                        onChange={this.handleEditorChange}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <div className="text-center">
                                            <Button className="dashboard_add_form_button">Update</Button>
                                        </div>
                                    </form>
                                </Col>
                            </Row>
                        </Fragment>
                }

            </Container>
        );

    }
}
